import React, { useState, useRef, useEffect } from 'react';
import Cookies from 'universal-cookie';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'


export default function RadialTimer(props) {

    const [isRunning, setIsRunning] = useState(true);
    const [isFocused, setIsFocused] = useState(false);
    const { getWrapper, getInput, isLoncin } = props;

    useEffect(() => {
        var wrapper = getWrapper();
        wrapper.current.addEventListener("mouseover", function (event) {
            setIsRunning(false);
        });
        wrapper.current.addEventListener("mouseleave", function (event) {
            setIsRunning(true);
        });
        var wrapper_input = getInput();
        wrapper_input.current.addEventListener("focus", function (event) {
            setIsFocused(true);

        });
    }, []);


    const renderContent = () => {
        return (
            <div className="time-wrapper" onClick={() => hide(true)}>
                <i className="fal fa-times"></i>
            </div>
        );
    };

    const UrgeWithPleasureComponent = () => (
        <CountdownCircleTimer
            isPlaying={isRunning && !isFocused}
            duration={15}
            size={32}
            strokeWidth={2}
            trailColor={`${isLoncin ? '#E94F25' : '#F9BD08'}`}
            onComplete={() => {
                (async () => {
                    hide(false);
                })()
            }}
            colors={[
                ['#fff'],
            ]}
        >
            {() =>
                renderContent(null, null)
            }

        </CountdownCircleTimer>
    )

    const hide = (setCookie) => {

        var _wrapper = getWrapper();
        setIsRunning(false);
        _wrapper.current.parentElement.classList.remove("move");
        if (setCookie) {
            const cookies = new Cookies();
            cookies.set('newsletter_prompt_status', 'dismissed', { maxAge: 432000, path: '/' });
        }
    }

    return (
        <div className="radial-timer-wrapper">
            <UrgeWithPleasureComponent />
        </div>
    );
}